import MarkdownRenderer from "../markdown/MarkdownRenderer";

const HumanMessage = ({ content }) => {
    if (!content) return
    return (<div className="human-message" style={{ maxWidth: '90%', display: 'flex', gap: '.3rem', padding: '1rem' }}>
        <div style={{ backgroundColor: 'var(--lightBlue)', borderRadius: '1rem', color: 'var(--white)', padding: '1rem' }}>
            {content}
            {/* <MarkdownRenderer>
                {content?.replace(/(\[.*?\])/g, "$1\n")}
            </MarkdownRenderer> */}
        </div>
    </div>)
}

export default HumanMessage